import { EfenceLayer } from '@/components/Layer/EfenceLayer'
import type { CesiumObj } from '../CesiumObj'
import type { BaseLayerI } from '@/components/Layer'
import { DynamicShipLayer } from '@/components/Layer/DynamicShip'
import { type layerConfig, layersTreeConfig } from '@/config'
import { EquipLayer } from '@/components/Layer/EquipLayer'
import { BouyLayer } from '@/components/Layer/BouyLayer'
import { SecondarywaterLayer } from '@/components/Layer/SecondarywaterLayer'
import { CameraLayer } from '@/components/Layer/CameraLayer'
import { WmsDwLayer } from '@/components/Layer/wmsDwLayer'
import { WmsFzuBouyLayer } from '@/components/Layer/wmsFzuBouyLayer'
import { WmsDwrtLayer } from '@/components/Layer/wmsDwrtLayer'
import { WmsDepthAreaLayer } from '@/components/Layer/wmsDepthAreaLayer'
import { Ship66Layer } from '@/components/Layer/Ship66'
import { DwrtLayer } from '@/components/Layer/DwrtLayer'
import { BridgeLayer } from '@/components/Layer/BridgeLayer'
import { AidStationLayer } from '@/components/Layer/AidStationLayer'
import { DockLayer } from '@/components/Layer/DockLayer'
import { GasStationLayer } from '@/components/Layer/GasStationLayer'
import { SandbarLayer } from '@/components/Layer/SandbarLayer'
import { AISVHFLayer } from '@/components/Layer/AISVHFLayer'

export class LayerManager {
  cesiumobj

  // 图层map
  layerMap = new Map<string, BaseLayerI>()
  /**图层初始化 */
  SecondarywaterLayer = new SecondarywaterLayer()
  efenceLayer = new EfenceLayer()
  dynamicShipLayer = new DynamicShipLayer()
  equipLayer = new EquipLayer()
  bouyLayer = new BouyLayer()
  cameraLayer = new CameraLayer()
  wmsDwLayer = new WmsDwLayer()
  wmsFzuBouyLayer = new WmsFzuBouyLayer()
  wmsDwrtLayer = new WmsDwrtLayer()
  WmsDepthAreaLayer = new WmsDepthAreaLayer()
  ship66Layer = new Ship66Layer()
  DwrtLayer = new DwrtLayer()
  BridgeLayer = new BridgeLayer()
  AidStationLayer = new AidStationLayer()
  DockLayer = new DockLayer()
  GasStationLayer = new GasStationLayer()
  SandbarLayer = new SandbarLayer()
  AISVHFLayer = new AISVHFLayer()

  constructor(cesiumobj: CesiumObj) {
    this.cesiumobj = cesiumobj

    /**map挂载 */
    this.layerMap.set(this.DwrtLayer.key, this.DwrtLayer)
    this.layerMap.set(this.DwrtLayer.key, this.DwrtLayer)
    this.layerMap.set(this.efenceLayer.key, this.efenceLayer)
    this.layerMap.set(this.dynamicShipLayer.key, this.dynamicShipLayer)
    this.layerMap.set(this.equipLayer.key, this.equipLayer)
    this.layerMap.set(this.bouyLayer.key, this.bouyLayer)
    this.layerMap.set(this.cameraLayer.key, this.cameraLayer)
    this.layerMap.set(this.wmsDwLayer.key, this.wmsDwLayer)
    this.layerMap.set(this.wmsFzuBouyLayer.key, this.wmsFzuBouyLayer)
    this.layerMap.set(this.wmsDwrtLayer.key, this.wmsDwrtLayer)
    this.layerMap.set(this.ship66Layer.key, this.ship66Layer)
    this.layerMap.set(this.BridgeLayer.key, this.BridgeLayer)
    this.layerMap.set(this.WmsDepthAreaLayer.key, this.WmsDepthAreaLayer)
    this.layerMap.set(this.SecondarywaterLayer.key, this.SecondarywaterLayer)
    this.layerMap.set(this.AidStationLayer.key, this.AidStationLayer)
    this.layerMap.set(this.DockLayer.key, this.DockLayer)
    this.layerMap.set(this.GasStationLayer.key, this.GasStationLayer)
    this.layerMap.set(this.SandbarLayer.key, this.SandbarLayer)
    this.layerMap.set(this.AISVHFLayer.key, this.AISVHFLayer)

    /**初始化操作 */
    this.initLayers(layersTreeConfig)
  }
  initLayers(layersConfig: layerConfig[]) {
    layersConfig.forEach((layerconfig) => {
      const target = this.layerMap.get(layerconfig.key)
      if (!target) return
      target.mount(this.cesiumobj.viewer)
      if (layerconfig.show == true) target.show()
    })
  }
}
